import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Notification, NotificationStatus } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { Observable } from 'rxjs';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    getByUser(tenantId: string): Observable<Notification[]> {
        return this.http.get<Notification[]>(this.serviceUtils.getBaseUrl('systemnotification', tenantId), {
            headers: this.httpHeadersWithNoLoading,
        });
    }

    markAsRead(tenantId: string, notificationId: string, status: NotificationStatus): Observable<Notification> {
        return this.http.put<Notification>(this.serviceUtils.getBaseUrl('systemnotification', tenantId) + `/${notificationId}/status/${status}`, {
            headers: this.httpHeadersWithNoLoading,
        });
    }

    /**
     * Marks every unread notification for the acting user as read in a single request.
     *
     * Issues `PUT api/v1/tenant/{tenantId}/systemnotification/mark-all-read`. The user is
     * resolved server-side from the authenticated principal, so no user identifier
     * is passed. The endpoint returns the bare count of notifications transitioned to read, not a
     * wrapper object.
     */
    markAllRead(tenantId: string): Observable<number> {
        return this.http.put<number>(this.serviceUtils.getBaseUrl('systemnotification', tenantId) + '/mark-all-read', null, {
            headers: this.httpHeadersWithNoLoading,
        });
    }

    save(tenantId: string, notification: Notification): Observable<Notification> {
        if (!notification.id || notification.id === null)
            return this.http.post<Notification>(this.serviceUtils.getBaseUrl('systemnotification', tenantId), notification, {
                headers: this.httpHeadersWithNoLoading,
            });
        else
            return this.http.put<Notification>(this.serviceUtils.getBaseUrl('systemnotification', tenantId), notification, {
                headers: this.httpHeadersWithNoLoading,
            });
    }
}
